import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    showCompletedCheck: {
        display: "flex",
        alignItems: "center",
        width: "168px",
    },
    bottomFilters: { display: "flex", alignItems: "flex-end", justifyContent: "space-between" },
    select: {
        width: 170,
    },
    rcaIssuesFiltersMainWrapper: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    mainFilters: {
        width: "100%",
        paddingLeft: 0,
    },
    title: {
        flex: 1,
    },
    searchBar: {
        margin: "0px 20px",
        width: "30%",
        [theme.breakpoints.down("lg")]: {
            width: "40%",
        },
    },
    meetingDropdown: {
        marginRight: "363px",
    },
}));
